import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m5.4 8 6-6c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-6 6c-.4.4-.4 1 0 1.4l6 6c.1.1.2.1.4.1.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7z" />
  </svg>
);
const SvgCaretRightNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="caret-right-next" {...props} />;
export default SvgCaretRightNext;
